<template>
  <div class="declareview" ref="previewDom" style="padding-bottom: 50px">
    <div class="a4">
      <h1 style="font-size: 30px; font-weight: 600">
        {{title || "2021年半年报"}}
      </h1>
      <p style="font-size: 22px; line-height: 40px;text-align:start">
        一、填报时间：{{ convertDateFromString(time)[0] }}年{{ convertDateFromString(time)[1] }}月{{ convertDateFromString(time)[2] }}日
      </p>
      <p style="font-size: 22px; line-height: 40px;text-align:start">二、企业概况</p>
      <div class="th">
          <div class="box justify-center" style="width:120px;height:50px">企业全称</div>
          <div class="box justify-center" style="width:600px;height:50px">{{ alldata.Enterpriseoverview.msg1 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:120px;height:50px">注册地址</div>
          <div class="box justify-center" style="width:600px;height:50px">{{ alldata.Enterpriseoverview.msg2 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:120px;height:50px">填 表 人</div>
          <div class="box justify-center" style="width:220px;height:50px">{{ alldata.Enterpriseoverview.msg3 }}</div>
          <div class="box justify-center" style="width:160px;height:50px">联系电话</div>
          <div class="box justify-center" style="width:222px;height:50px">{{ alldata.Enterpriseoverview.msg4 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:120px;height:90px">企业性质</div>
          <div class="box justify-center" style="width:600px;height:90px;font-size:22px">
              {{ panduan(alldata.Enterpriseoverview.msg5,'中央企业') }}   {{ panduan(alldata.Enterpriseoverview.msg5,'省属国有企业') }}    {{ panduan(alldata.Enterpriseoverview.msg5,'民营企业') }}   {{ panduan(alldata.Enterpriseoverview.msg5,'集体企业') }}   <br/><br/>{{ panduan(alldata.Enterpriseoverview.msg5,'混合所有制企业') }}   {{ panduan(alldata.Enterpriseoverview.msg5,'其他') }}
          </div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:120px;height:100px">企业资质类型及等级</div>
          <div class="box justify-start" style="width:600px;height:100px;font-size:20px;padding-left:10px">
            {{alldata.Enterpriseoverview.msg6}}
              <!-- <p>{{ panduan(alldata.Enterpriseoverview.msg6,'施工总承包特级') }}     {{ panduan(alldata.Enterpriseoverview.msg6,'施工总承包一级') }}    {{ panduan(alldata.Enterpriseoverview.msg6,'施工总承包二级及以下') }}</p>
              <p>{{ panduan(alldata.Enterpriseoverview.msg6,'专业承包一级') }}       {{ panduan(alldata.Enterpriseoverview.msg6,'专业承包二级') }}      {{ panduan(alldata.Enterpriseoverview.msg6,'专业承包二级以下') }}</p>
              <p>{{ panduan(alldata.Enterpriseoverview.msg6,'劳务分包一级') }}       {{ panduan(alldata.Enterpriseoverview.msg6,'劳务分包二级') }}      {{ panduan(alldata.Enterpriseoverview.msg6,'劳务分包二级以下') }}</p> -->
          </div>
      </div>
      <h2 style="text-align:start">
          二、企业生产经营情况
      </h2>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;font-weight:600;background:#ececec">指标</div>
          <div class="box justify-center" style="width:160px;height:40px;font-weight:600;background:#ececec">单位</div>
          <div class="box justify-center" style="width:300px;height:40px;font-weight:600;background:#ececec">半年度（1月-6月）</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">完成总产值</div>
          <div class="box justify-center" style="width:160px;height:40px;">亿元</div>
          <div class="box justify-center" style="width:300px;height:40px;">{{ alldata.Operation.msg1 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">应收账款</div>
          <div class="box justify-center" style="width:160px;height:40px;">亿元</div>
          <div class="box justify-center" style="width:300px;height:40px;">{{ alldata.Operation.msg2 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">现金流</div>
          <div class="box justify-center" style="width:160px;height:40px;">亿元</div>
          <div class="box justify-center" style="width:300px;height:40px;">{{ alldata.Operation.msg3 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">实现利润</div>
          <div class="box justify-center" style="width:160px;height:40px;">亿元</div>
          <div class="box justify-center" style="width:300px;height:40px;">{{ alldata.Operation.msg4 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">总资产</div>
          <div class="box justify-center" style="width:160px;height:40px;">亿元</div>
          <div class="box justify-center" style="width:300px;height:40px;">{{ alldata.Operation.msg5 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">资产负债率</div>
          <div class="box justify-center" style="width:160px;height:40px;">%</div>
          <div class="box justify-center" style="width:300px;height:40px;">{{ alldata.Operation.msg6 }}</div>
      </div>
      <div class="th">
          <div class="box" style="width:50px;height:160px;display:flex;flex-direction: column-reverse;font-size:26px">业务</div>
          <div class="box" style="width:211px;height:160px;">
              <div class="box justify-center" style="width:211px;height:42px;margin-top:-1px">建筑施工</div>
              <div class="th">
                  <div class="box justify-center" style="width:50px;height:120px">其中</div>
                  <div class="box justify-center" style="width:161px;height:120px;">
                    <div class="box justify-center" style="width:161px;height:40px;margin-top:-1px">住宅类项目</div>
                    <div class="box justify-center" style="width:161px;height:40px;">公共类项目</div>
                    <div class="box justify-center" style="width:161px;height:42px;">工业类项目</div>
                  </div>
              </div>
              
          </div>
            <div class="box" style="width:460px;height:160px;">
                <div class="th">
                    <div class="box justify-center" style="width:160px;height:41px;">亿元</div>
                    <div class="box justify-center" style="width:300px;height:41px;">{{ alldata.Operation.msg7 }}</div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:160px;height:40px;">亿元</div>
                    <div class="box justify-center" style="width:300px;height:40px;">{{ alldata.Operation.msg8 }}</div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:160px;height:40px;">亿元</div>
                    <div class="box justify-center" style="width:300px;height:40px;">{{ alldata.Operation.msg9 }}</div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:160px;height:41px;">亿元</div>
                    <div class="box justify-center" style="width:300px;height:41px;">{{ alldata.Operation.msg10 }}</div>
                </div>
            </div>
      </div>
    </div>
    <div class="a4">
        <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;font-weight:600;background:#ececec">指标</div>
          <div class="box justify-center" style="width:160px;height:40px;font-weight:600;background:#ececec">单位</div>
          <div class="box justify-center" style="width:300px;height:40px;font-weight:600;background:#ececec">半年度（1月-6月）</div>
        </div>
        <div class="th" style="display:flex;align-items:start">
            <div class="box" style="width:50px;height:1045px;font-size:24px">结<br/>构</div>
            <div class="flex-direction">
                <div class="th" style="display:flex;align-items:start">
                    <div class="box" style="width:50px;height:160px"></div>
                    <div class="flex-direction">
                        <div class="box justify-center" style="width:163px;height:80px">装配式混凝土项目</div>
                        <div class="box justify-center" style="width:163px;height:81px">装配式钢结构项目</div>
                    </div>
                    <div class="flex-direction">
                        <div class="box justify-center" style="width:160px;height:40px">万平方米</div>
                        <div class="box justify-center" style="width:160px;height:41px">亿元</div>
                        <div class="box justify-center" style="width:160px;height:41px">万平方米</div>
                        <div class="box justify-center" style="width:160px;height:41px">亿元</div>
                    </div>
                    <div class="flex-direction">
                        <div class="box justify-start" style="width:300px;height:40px">面积：{{ alldata.Operation.msg11 }}</div>
                        <div class="box justify-start" style="width:300px;height:41px">产值：{{ alldata.Operation.msg12 }}</div>
                        <div class="box justify-start" style="width:300px;height:41px">面积：{{ alldata.Operation.msg13 }}</div>
                        <div class="box justify-start" style="width:300px;height:41px">产值：{{ alldata.Operation.msg14 }}</div>
                    </div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:212px;height:40px">市政施工</div>
                    <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                    <div class="box" style="width:300px;height:40px">{{ alldata.Operation.msg15 }}</div>
                </div>
                <div class="th" style="display:flex;align-items:start">
                    <div class="box justify-center" style="width:50px;height:299px;font-size:24px">其<br/>中</div>
                    <div class="flex-direction">
                        <div class="th">
                            <div class="box justify-center" style="width:163px;height:40px">城市道路项目</div>
                            <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                            <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg16 }}</div>
                        </div>
                        <div class="th">
                            <div class="box justify-center" style="width:163px;height:40px">轨道交通项目</div>
                            <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                            <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg17 }}</div>
                        </div>
                        <div class="th">
                            <div class="box justify-center" style="width:163px;height:72px">地下管廊（线）项目</div>
                            <div class="box justify-center" style="width:160px;height:72px">亿元</div>
                            <div class="box justify-center" style="width:300px;height:72px">{{ alldata.Operation.msg18 }}</div>
                        </div>
                        <div class="th">
                            <div class="box justify-center" style="width:163px;height:40px">绿化景观项目</div>
                            <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                            <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg19 }}</div>
                        </div>
                        <div class="th">
                            <div class="box justify-center" style="width:163px;height:72px">污水（垃圾）处理项目</div>
                            <div class="box justify-center" style="width:160px;height:72px">亿元</div>
                            <div class="box justify-center" style="width:300px;height:72px">{{ alldata.Operation.msg20 }}</div>
                        </div>
                        <div class="th">
                            <div class="box justify-center" style="width:163px;height:40px">其他项目</div>
                            <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                            <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg21 }}</div>
                        </div>
                    </div>
                    
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:212px;height:80px">房地产开发</div>
                    <div class="flex-direction">
                        <div class="box justify-center" style="width:160px;height:41px">万㎡</div>
                        <div class="box justify-center" style="width:160px;height:40px">面积：{{ alldata.Operation.msg22 }}</div>
                    </div>
                    <div class="flex-direction">
                        <div class="box justify-start" style="width:300px;height:41px">亿元</div>
                        <div class="box justify-start" style="width:300px;height:40px">收入：{{ alldata.Operation.msg23 }}</div>
                    </div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:212px;height:40px">铁路施工</div>
                    <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                    <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg24 }}</div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:212px;height:40px">公路施工</div>
                    <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                    <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg25 }}</div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:212px;height:40px">电力施工</div>
                    <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                    <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg26 }}</div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:212px;height:40px">煤炭施工</div>
                    <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                    <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg27 }}</div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:212px;height:40px">冶金施工</div>
                    <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                    <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg28 }}</div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:212px;height:40px">石油化工施工</div>
                    <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                    <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg29 }}</div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:212px;height:40px">建材装饰施工</div>
                    <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                    <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg30 }}</div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:212px;height:40px">水利施工</div>
                    <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                    <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg31 }}</div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:212px;height:40px">海外项目</div>
                    <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                    <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg32 }}</div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:212px;height:80px">PPP项目数量及投资额</div>
                    <div class="flex-direction">
                        <div class="box justify-center" style="width:160px;height:41px">个</div>
                        <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                    </div>
                    <div class="flex-direction">
                        <div class="box justify-center" style="width:300px;height:41px">{{ alldata.Operation.msg33 }}</div>
                        <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg34 }}</div>
                    </div>
                </div>
                <div class="th">
                    <div class="box justify-center" style="width:212px;height:40px">（  其他  ）</div>
                    <div class="box justify-center" style="width:160px;height:40px">亿元</div>
                    <div class="box justify-center" style="width:300px;height:40px">{{ alldata.Operation.msg35 }}</div>
                </div>
            </div>
            
        </div>
        
    </div>
    <div class="a4">
        <h2 style="text-align:start">
          三、科技创新与人才队伍
        </h2>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;font-weight:600;background:#ececec">指标</div>
          <div class="box justify-center" style="width:100px;height:40px;font-weight:600;background:#ececec">单位</div>
          <div class="box justify-center" style="width:360px;height:40px;font-weight:600;background:#ececec">半年度（1月-6月）</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">高新技术及科技研发投入</div>
          <div class="box justify-center" style="width:100px;height:40px;">万元</div>
          <div class="box justify-center" style="width:360px;height:40px;">{{ alldata.innovate8 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:80px;">获得国家级奖项数量和名称</div>
          <!-- <div class="box justify-center" style="width:100px;height:80px;">个</div> -->
          <div class="box justify-center" style="width:460px;height:80px;">{{ alldata.innovate1 }}个：{{ alldata.innovate2 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:80px;">获得省、市级奖项数量和名称</div>
          <!-- <div class="box justify-center" style="width:100px;height:80px;">个</div> -->
          <div class="box justify-center" style="width:460px;height:80px;">{{ alldata.innovate3 }}个：{{ alldata.innovate4 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">技术中心级别和数量</div>
          <!-- <div class="box justify-center" style="width:100px;height:40px;">个</div> -->
          <div class="box justify-center" style="width:460px;height:40px;">{{ alldata.innovate9 }}{{ alldata.innovate10 }}个</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:80px;">获得专利数量及名称</div>
          <!-- <div class="box justify-center" style="width:100px;height:80px;">个</div> -->
          <div class="flex-direction">
              <div class="box" style="width:460px;height:40px;">发明专利：{{ alldata.innovate6 }}</div>
              <div class="box" style="width:460px;height:41px;">实用型专利：{{ alldata.innovate7 }}</div>
          </div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">行政管理人员数量</div>
          <div class="box justify-center" style="width:100px;height:40px;">个</div>
          <div class="box justify-center" style="width:360px;height:40px;">{{ alldata.innovate11 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">接收应届毕业生数量</div>
          <div class="box justify-center" style="width:100px;height:40px;">个</div>
          <div class="box justify-center" style="width:360px;height:40px;">{{ alldata.innovate12 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">专职科技研发人员数量</div>
          <div class="box justify-center" style="width:100px;height:40px;">个</div>
          <div class="box justify-center" style="width:360px;height:40px;">{{ alldata.innovate13 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">院士数量</div>
          <div class="box justify-center" style="width:100px;height:40px;">个</div>
          <div class="box justify-center" style="width:360px;height:40px;">{{ alldata.innovate14 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">技能大师数量</div>
          <div class="box justify-center" style="width:100px;height:40px;">个</div>
          <div class="box justify-center" style="width:360px;height:40px;">{{ alldata.innovate15 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">博士学历人员数量</div>
          <div class="box justify-center" style="width:100px;height:40px;">个</div>
          <div class="box justify-center" style="width:360px;height:40px;">{{ alldata.innovate16 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">硕士学历人员数量</div>
          <div class="box justify-center" style="width:100px;height:40px;">个</div>
          <div class="box justify-center" style="width:360px;height:40px;">{{ alldata.innovate17 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">注册类人员数量</div>
          <div class="box justify-center" style="width:100px;height:40px;">个</div>
          <div class="box justify-center" style="width:360px;height:40px;">{{ alldata.innovate18 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">中、高级职称人员数量</div>
          <div class="box justify-center" style="width:100px;height:40px;">个</div>
          <div class="box justify-center" style="width:360px;height:40px;">{{ alldata.innovate19 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:261px;height:40px;">中、高级技工数量</div>
          <div class="box justify-center" style="width:100px;height:40px;">个</div>
          <div class="box justify-center" style="width:360px;height:40px;">{{ alldata.innovate20 }}</div>
      </div>
      <div style="margin-top:140px">
          <p style="text-align:start;font-size:24px;line-height:40px">
              填表须知：<br/>
                  1、本企业郑重承诺所填数据皆为真实数据，无不实、捏造、造假情况，对上传所有内容负责；
          </p>
      </div>
      
    </div>
    <div class="a4">
        <div style="margin-top:40px">
          <p style="text-align:start;font-size:24px;line-height:40px">
              2、注册类人员包括一、二级注册建造师、注册造价师、注册监理工程师、注册安全工程师、注册会计师。（若一人有多种执业资格，只计算一次）<br/>
              3、中、高级技工指企业内从事相关工种，包括瓦工、钢筋工、混凝土工、抹灰工、防水工、管道工、水暖工、测量放线工、木工、电焊工、油漆工、安装起重工、电气设备安装调试工、工程机械维修工、中小型机械操作工等，经市级以上建筑职业技能岗位主管部门培训考核，取得中级技工及以上级别的人员。<br/>
              4、所有内容只限于调研分析所用，将会严格保密。在填写过程中有任何疑问请致电：0851-85360455；
          </p>
      </div>
    </div>
  </div>
</template>
<script>
import "../word/pdfview.less";
export default {
  props: {
    alldata: {
      type: Object,
    },
    time:String,
    title:String
  },
  data() {
    return {
      mdStyle: {},
      pdfandimg: [],
      loadingTask: "",
      numPages: null,
      url: "",
    };
  },
  mounted() {
    this.$emit("previewDom", this.$refs.previewDom); //整页DOM上传至父组件
    console.log("declare", this.time)
    this.convertDateFromString(this.time)
  },
  methods: {
    fn() {},
    panduan(msg,oldmsg){
        return msg == oldmsg?'☑'+oldmsg:'□'+oldmsg
    },
     convertDateFromString(dateString) { 
      if (dateString) { 
      var arr1 = dateString.split(" "); 
      var sdate = arr1[0].split('-'); 
      // var date = new Date(sdate[0], sdate[1]-1, sdate[2]); 
      // console.log(sdate,date.toLocaleString())
      return sdate;
    } 
}   
  },
};
</script>

<style lang="less" scoped>
.flex-direction{
    display: flex;
    flex-direction: column;
}
</style>